import React from 'react';
export function Footer() {
  const links = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Gift Cards',
    href: '#gift-cards'
  }, {
    name: 'Contact',
    href: '#contact'
  }, {
    name: 'Book Online',
    href: '#book'
  }];
  return <footer className="bg-[#111111] py-12 border-t border-white/5" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-60">
        <img src="https://cdn.magicpatterns.com/uploads/kHPY5hn7jL6QdVkj1vf8yR/raise_the_bar_white.png" alt="Raise The Bar Logo" className="w-[100px] mb-8 opacity-80 hover:opacity-100 transition-opacity" data-id="element-61" />

        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 mb-10" data-id="element-62">
          {links.map(link => <a key={link.name} href={link.href} className="text-white/80 hover:text-[#C8A84E] transition-colors text-sm tracking-wide uppercase" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} data-id="element-63">
              {link.name}
            </a>)}
        </div>

        <div className="space-y-2" style={{
        fontFamily: "'Montserrat', sans-serif"
      }} data-id="element-64">
          <p className="text-white/60 text-sm" data-id="element-65">
            © 2025 Raise The Bar Med Spa | All Rights Reserved
          </p>
          <p className="text-white/40 text-xs" data-id="element-66">
            Gilbert, AZ Medical Spa — Botox, Fillers, Facials, Microneedling &
            More
          </p>
        </div>
      </div>
    </footer>;
}